// extracted by mini-css-extract-plugin
module.exports = {"MakePayMentLoading":"ScR6d","fadenum":"_3vPIH","clickDetails":"_2qDY1","MakePayMentSuccess":"gExQ4","MakePayMentError":"_1rVYF","descWrap":"_3Ionx"};